import type { AdminFinanceStats } from '../../../domain/superadmin/types';
import { formatCurrency } from '../../../utils/formatters';
import DashboardCard from '../../dashboard/components/DashboardCard';

type AddonsSectionProps = {
  addons: AdminFinanceStats['addons'];
};

export function AddonsSection({ addons }: AddonsSectionProps) {
  const { extraSeats } = addons;

  return (
    <section aria-label="Add-ons ativos" className="mb-s5">
      <DashboardCard title="Add-ons ativos">
        <p className="mb-s4 text-[12px] text-muted">
          Assentos extras e canais com preço cadastrado
        </p>
        <div className="grid gap-s3 sm:grid-cols-2">
          {extraSeats.count > 0 ? (
            <div className="rounded-lg border border-subtle bg-surface px-s4 py-3">
              <p className="text-[11px] font-semibold uppercase tracking-[0.07em] text-muted">
                Usuários extras
              </p>
              <p className="mt-1 font-mono text-[22px] font-semibold tabular-nums text-default">
                {extraSeats.count}
              </p>
              <p className="mt-0.5 text-[12px] text-muted">
                {formatCurrency(extraSeats.mrrCents / 100, 'BRL')} MRR
              </p>
            </div>
          ) : (
            <p className="rounded-lg border border-dashed border-border bg-surface px-s4 py-6 text-center text-[13px] text-muted">
              Nenhum assento extra ativo.
            </p>
          )}
          <p className="rounded-lg border border-dashed border-border bg-surface px-s4 py-6 text-center text-[13px] text-muted">
            Sem add-ons de canal com preço cadastrado.
          </p>
        </div>
      </DashboardCard>
    </section>
  );
}
